<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Normal ParaOverride-1"><span class="Bold CharOverride-3">Sustainable<br/></span><span class="Bold CharOverride-4">Badass</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">A Zero-Waste Lifestyle Guide</span></p>
<p class="Normal ParaOverride-3"><span class="Bold CharOverride-6">Gittemarie Johansen</span></p>
<p class="Normal ParaOverride-4"><span class="CharOverride-7"><img alt="" src="image/MangoPublishingLogo(cmyk).png"/></span></p>
<p class="Normal ParaOverride-5"><span class="CharOverride-8">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SustainableBadass-1.vue?405aa42f